(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crewready-shelves"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cr-shelf').forEach((shelf) => {
  if (shelf.dataset.crShelfBound === 'true') return;
  const track = shelf.querySelector('[data-cr-shelf-track]');
  const prev = shelf.querySelector('[data-cr-shelf-prev]');
  const next = shelf.querySelector('[data-cr-shelf-next]');
  if (!track || !prev || !next) return;
  shelf.dataset.crShelfBound = 'true';
  const scrollAmount = () => Math.max(260, track.clientWidth * 0.82);
  prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
  next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
